import { CAvatar, CButton, CCard, CCardBody, CCol, CContainer, CFooter, CRow } from '@coreui/react'
import { MedicalInformation } from '@mui/icons-material'
import React from 'react'
import avatar8 from './../../assets/images/avatars/logo1.jpg'
import { motion } from 'framer-motion'

import { Link } from 'react-router-dom'
import { ChevronRight, Clipboard, Receipt } from 'lucide-react'
import { Button } from 'react-bootstrap'
const Homepage = () => {
    const services = [
        {
            title: 'Notes',
            description:
                'Accurate and detailed patient record documentation following standards.',
            icon: MedicalInformation
        },
    ]
    return (
      <div>
        <div className="min-h-screen">
          {/* Navigation */}
          <nav className="navbar navbar-expand-lg navbar-light bg-white shadow-sm">
            <div className="container">
              <div className="d-flex align-items-center">
                <CAvatar src={avatar8} style={{ width: '3rem', borderRadius: '0' }} />
                <span className=" " style={{ color: '#4FC3F7', fontSize: '15px', padding: '0px 10px' }}>
                  Provio Solutions
                </span>
              </div>

              <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
                <span className="navbar-toggler-icon"></span>
              </button>
              <div className="collapse navbar-collapse" id="navbarNav">
                <ul className="navbar-nav ms-auto">
                  <li className="nav-item">
                    <a className="nav-link" href="#services">
                      Services
                    </a>
                  </li>
                  {/* <li className="nav-item">
                                    <a className="nav-link" href="#about">Career</a>
                                </li> */}
                  <li className="nav-item pl-4 ml-2">
                    <Link to="/login">
                      <Button>Login</Button>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </nav>

          {/* Hero Section */}
          <section
            style={{
              padding: '100px 0',
              background: 'linear-gradient(135deg, #fefefe 0%, #e3f2fd 100%)',
            }}
          >
            <CContainer>
              <CRow className="align-items-center">
                <CCol lg={6} className="text-center text-lg-start mb-3 mb-lg-0">
                  <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, ease: 'easeOut' }}
                    whileHover={{ scale: 1.02 }}
                    style={{
                      background: 'rgba(255, 255, 255, 0.85)',
                      padding: '1.5rem',
                      borderRadius: '0.75rem',
                      boxShadow: '0 0 10px rgba(0,0,0,0.08)',
                    }}
                  >
                    <h2 className="fw-semibold mb-2" style={{ fontSize: '1.75rem', color: '#212529' }}>
                      Professional Note-Making Services
                    </h2>
                    <p className="text-secondary mb-3" style={{ fontSize: '0.95rem' }}>
                      Streamline your documentation with our expert note-taking — accurate, timely, and fully compliant.
                    </p>
                    <div className="d-flex flex-column flex-sm-row gap-2 justify-content-center justify-content-lg-start">
                    
                        <Link to="/login">
                         
                          <CButton color="primary" size="sm" className="px-3">
                        
                            Login
                          </CButton> 
                        </Link>
                      
                      <CButton color="outline-primary" size="sm" className="px-3">
                        Learn More
                      </CButton>
                    </div>
                  </motion.div>
                </CCol>
              </CRow>
            </CContainer>
          </section>

          {/* Services Section */}
          <section id="services" className="py-5 bg-white">
            <CContainer>
              {/* Heading */}
              <div className="text-center mb-4">
                <h2 className="fw-bold" style={{ fontSize: '1.875rem' }}>
                  Our Services
                </h2>
                <p className="text-secondary" style={{ maxWidth: '40rem', margin: '0 auto', fontSize: '1rem' }}>
                  Professional, timely, and reliable documentation solutions tailored to your needs
                </p>
              </div>

              {/* Single Service Card */}
              <CRow className="justify-content-center">
                <CCol md={6} lg={4} className="d-flex align-items-center justify-content-center">
                  <CCard
                    className="w-100 h-100 border-0 shadow p-3 transition"
                    style={{
                      borderRadius: '1rem',
                      cursor: 'pointer',
                      transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-4px)'
                      e.currentTarget.style.boxShadow = '0 16px 28px rgba(0,0,0,0.1)'
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = ''
                      e.currentTarget.style.boxShadow = ''
                    }}
                  >
                    <CCardBody>
                      <div
                        className="d-inline-flex align-items-center justify-content-center mb-3"
                        style={{
                          width: '56px',
                          height: '56px',
                          borderRadius: '0.75rem',
                          backgroundColor: services[0].color, // use color from your service object
                        }}
                      >
                        <div className="bg-primary bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-2 mx-auto" style={{ width: '56px', height: '56px' }}>
                          <MedicalInformation style={{ width: '28px', height: '28px' }} className="text-white" />
                        </div>
                      </div>
                      <h3 className="h5 fw-bold mb-2">{services[0].title}</h3>
                      <p className="text-secondary mb-3" style={{ minHeight: '60px', fontSize: '0.9rem' }}>
                        {services[0].description}
                      </p>
                      <div className="d-flex align-items-center text-primary fw-semibold">
                        Learn More
                        <ChevronRight className="ms-1" style={{ width: '1rem', height: '1rem' }} />
                      </div>
                    </CCardBody>
                  </CCard>
                </CCol>
              </CRow>
            </CContainer>
          </section>

          {/* Footer */}
          <CFooter className="bg-dark border-top py-3">
            <CContainer>
              <CRow className="align-items-center">
                <CCol md={12} className="text-center text-md-end white text-white">
                  <Link to="/privacy-policy" className="text-white text-decoration-none" style={{ fontWeight: 500 }}>
                    Privacy Policy
                  </Link>
                </CCol>
              </CRow>
            </CContainer>
          </CFooter>
        </div>
      </div>
    )
}

export default Homepage